import { render } from "./OrdersByPortalViewer.vue?vue&type=template&id=65d0938c&scoped=true"
import script from "./OrdersByPortalViewer.vue?vue&type=script&lang=js"
export * from "./OrdersByPortalViewer.vue?vue&type=script&lang=js"

import "./OrdersByPortalViewer.vue?vue&type=style&index=0&id=65d0938c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d0938c"]])

export default __exports__